import { type HTMLAttributes, type ReactNode } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Padding interno. 'md' = 16px, 'sm' = 12px, 'none' = sem padding. */
  padding?: 'md' | 'sm' | 'none';
  children?: ReactNode;
}

/**
 * Container base do design system. Equivale ao `.card` do protótipo v2.
 * Use para qualquer bloco com superfície elevada (lista, painel, modal body).
 */
export function Card({
  padding = 'md',
  className = '',
  children,
  ...rest
}: CardProps) {
  const pad =
    padding === 'md' ? 'p-4' :
    padding === 'sm' ? 'p-3' :
    '';

  return (
    <div
      className={`bg-jf-surface border border-jf-border rounded-xl ${pad} ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}

/**
 * Título de seção dentro de um Card. Equivale ao `card-title` do protótipo —
 * texto pequeno, uppercase, muted.
 */
export function CardTitle({ children, className = '' }: { children: ReactNode; className?: string }) {
  return (
    <h2 className={`text-xs font-bold text-jf-muted uppercase tracking-wide mb-3 ${className}`}>
      {children}
    </h2>
  );
}
